export class WFReimbursementAttachReceiptParametersDto {
    communityId: number;
    lineItemWorkflowId: number;
    filename: string;
    fileBase64String: string;
}
